import { Menu } from "@headlessui/react";
import clsx from "clsx";

import { Check } from "@/assets/icons/icons";
import { FCC } from "@/types";

type Styles = {
  button?: string;
  icon?: string;
  selected?: string;
};

type Props = {
  code: string;
  customStyles?: Styles;
  label: string;
  selected: boolean;
  onSelect: (code: string) => void;
};

/**
 * LanguageOption - Atomic component for a selectable language option
 * Used within language menus and selection components
 */
export const LanguageOption: FCC<Props> = ({
  code,
  label,
  selected,
  onSelect,
  customStyles,
}) => {
  return (
    <Menu.Item key={`lang-${code}`}>
      {({ active }) => (
        <button
          id={`language-${code}`}
          className={clsx(
            "font-small mb-4 flex w-full cursor-pointer justify-between md:mb-2",
            customStyles?.button,
            active && "underline",
            selected && "font-semibold",
            selected && customStyles?.selected,
          )}
          onClick={() => onSelect(code)}
        >
          {label}
          {selected && (
            <div
              className={clsx(
                "ml-2 text-white md:text-primary-100",
                customStyles?.icon,
              )}
            >
              <Check />
            </div>
          )}
        </button>
      )}
    </Menu.Item>
  );
};
